export const emptyStateTranslationKeys = {
  header: 'ExternalComponent_add_component_empty_state_on_stage_header',
  body: 'ExternalComponent_add_component_empty_state__on_stage_body',
};

export const emptyStateDefaultValue = {
  header: 'Add any React Component to your site',
  body: 'Go to Settings to get started.',
};
